import type { ComponentType } from 'react'
import styled from 'styled-components'

import type { TextProps } from '@awazevr/design-system.components.text'
import { Text } from '@awazevr/design-system.components.text'

const StylableText = Text as unknown as ComponentType<TextProps>

export const StyledPrice = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.25rem;
`

export const StyledWasPrice = styled(StylableText)`
  font-weight: 500;
  text-decoration: line-through;
`
